<template>
<div class="Excitation">
    <div class="banner">
        <div class="page-module">
            <div class="card-left">
                <p class="name animated fadeInUp">股权激励方案定制助手</p>
                <p class="msg animated fadeInUp">一键生成专业实操方案，内容全面细致，让企业轻松搞定股权激励</p>
                <div class="button animated fadeInUp">
                    <button class="btn-style" @click="goto()">免费获取<div class="line"></div></button>
                </div>
            </div>
            <div class="card-right">
                <img class="img-1 animated fadeInUp" src="~common/images/gujing/excitation/jl-banner_1.png" alt="1">
                <img class="img-2 animated fadeInUp" src="~common/images/gujing/excitation/jl-banner_2.png" alt="1">
            </div>
        </div>
    </div>
    <div class="item-1 item">
        <div class="page-module animated">
            <div class="left-content">
                <p class="name">全面考虑方案设计核心要素</p>
                <p class="msg">方案囊括股权激励全部核心要素，内容涵盖股份来源、持股方式、激励对象范围、激励股份总量与个量分配、授予价格、分红规定、退出机制等，确保方案完整、内容全面。</p>
            </div>
            <div class="right-img">
                <img class="img-1" src="~common/images/gujing/excitation/jl-icon_1.png" alt="1">
            </div>
        </div>
    </div>
    <div class="item-2 item">
        <div class="page-module animated">
            <div class="left-content">
                <p class="name">方案即下即用 实操性强</p>
                <p class="msg">符合企业实际情况和激励需求<br/>拒绝套路性模板<br/>方案可直接落地实施</p>
            </div>
            <div class="right-img">
                <img class="img-1" src="~common/images/gujing/excitation/jl-icon_2.png" alt="1">
            </div>
        </div>
    </div>
    <div class="item-3 item">
        <div class="page-module animated">
            <div class="left-content">
                <p class="name">合法合规 规避风险</p>
                <p class="msg">规避雷区、排除隐患<br/>确保方案在法律框架下有效运行</p>
            </div>
            <div class="right-img">
                <img class="img-1" src="~common/images/gujing/excitation/jl-icon_3.png" alt="1">
            </div>
        </div>
    </div>

    <div class="server">
        <div class="page-module animated">
            <p class="name">专项服务</p>
            <div class="msg">
                <ul>
                    <li>
                        <img src="~common/images/gujing/excitation/jl-servce-icon_1.png" alt="1">
                        <p class="title">股权架构设计</p>
                        <p>充分保障创始人控制权</p>
                        <p>合理规划未来股权布局</p>
                        <p>有效设计公司治理结构</p>
                    </li>
                    <li>
                        <img src="~common/images/gujing/excitation/jl-servce-icon_2.png" alt="1">
                        <p class="title">股权激励落地实施</p>
                        <p>配套文件撰写</p>
                        <p>方案落地宣讲</p>
                        <p>知识培训与答疑</p>
                        <p>授予仪式协助</p>
                    </li>
                    <li>
                        <img src="~common/images/gujing/excitation/jl-servce-icon_3.png" alt="1">
                        <p class="title">财税筹划</p>
                        <p>税收优惠政策指导</p>
                        <p>股权重组财税筹划</p>
                        <p>税收风险防范</p>
                        <p>股份支付财税测算</p>
                    </li>
                    <li>
                        <img src="~common/images/gujing/excitation/jl-servce-icon_4.png" alt="1">
                        <p class="title">持股平台搭建</p>
                        <p>持股平台架构设计</p>
                        <p>预留股份设计</p>
                        <p>定制化合伙协议设计</p>
                        <p>税收洼地持股平台便捷注册</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import {mapGetters, mapActions} from 'vuex'
import "animate.css/animate.min.css"
export default {
    name: 'Excitation',
    data() {
        return {}
    },
    //判断pc或者移动，然后路由跳转
    created() {
        // console.log('this.domainInfo.isMobile',this.domainInfo)
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MExcitation'
            })
        }
    },
    mounted() {
        $('html').scrollTop(0)
        $('.gj-footer').css("margin-top","0")
      $(".gj_header").addClass('gj_top_header')
      if (this.animationScrool) {
          window.addEventListener('scroll', this.animationScrool)
      }
       this.animationScrool()
       $(window).bind("scroll",function(){  
           if (this.animationScrool) {
               this.animationScrool()
           }
        });
    },
    methods: {
        animationScrool() { // 鼠标滚动事件监控，进行动画 top 动画事件
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
            // console.log(scrollTop)
            // 添加滚动条
            if (this.$route.name == "Excitation") {
                if (scrollTop > 10) {
                    if ($(".gj_header").hasClass('gj_top_header')) {
                        $(".gj_header").removeClass('gj_top_header')
                    }
                }
                if (scrollTop == 0) {
                    $(".gj_header").addClass('gj_top_header')
                }
            }

            if (scrollTop < 700) {
                if (!$(".item-1 .page-module").hasClass('fadeInUp')) {
                    $(".item-1 .page-module").addClass('fadeInUp')
                }
            }
            if (scrollTop > 50 && scrollTop < 1100) {
                 if (!$(".item-2 .page-module").hasClass('fadeInUp')) {
                    $(".item-2 .page-module").addClass('fadeInUp')
                }
            }
            if (scrollTop > 400 && scrollTop < 1400) {
                 if (!$(".item-3 .page-module").hasClass('fadeInUp')) {
                    $(".item-3 .page-module").addClass('fadeInUp')
                }
             }
             if (scrollTop > 803) {
                 if (!$(".server .page-module").hasClass('fadeInUp')) {
                    $(".server .page-module").addClass('fadeInUp')
                }
             }
            
        },
        goto() {    // 跳转
            if (this.user.isLogin) {
                // 跳转到估值页面
                this.$router.push({name: 'ExcitationStep'})
            } else {
                // 登录弹窗
                this.setLoginPop(true)
            }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'domainInfo'
        ])
    },
    destroyed() {
        $(".gj_header").removeClass('gj_top_header')
        $('.gj-footer').css("margin-top","40px")
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.Excitation {
    background: #fff;
    // background-color: rgb(225, 236, 193);
    // padding-top: 64px;
    .banner {
        height: 500px;
        background: url('../../../common/images/gujing/gz/banner-bg.png') no-repeat center;
        background-size: 1920px 500px;

        .card-left {
            float: left;
            margin-top: 114px;
            p {
                color: #fff;
            }
            .name {
                font-size: 40px;
                font-weight:500;
            }
            .msg {
                margin-top: 37px;
                font-size: 20px;
            }
            .button {
                width: 180px;
                
                .btn-style {
                    position: relative;
                    overflow: hidden;
                    margin-top: 60px;
                    width:180px;
                    height:50px;
                    background:linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -webkit-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -ms-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -moz-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -o-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    border-radius:25px;
                    border: none;
                    cursor: pointer;
                    color: #fff;
                    font-size: 20px;

                    &:hover {
                        .line {
                            left: 160px;
                            transition: all .6s;
                            -webkit-transition: all .6s;
                            -ms-transition: all .6s;
                            -o-transition: all .6s;
                            -moz-transition: all .6s;
                        }
                    }
                    .line {
                        position: absolute;
                        width: 100px;
                        height: 25px;
                        background: rgba(255,255,255,.3);
                        transform: rotateZ(45deg);
                        bottom: 15px;
                        left: -80px;
                        transition: all 0;
                        -webkit-transition: all 0;
                        -ms-transition: all 0;
                        -o-transition: all 0;
                        -moz-transition: all 0;
                    }
                }
            }
        }
        .card-right {
            float: right;
            position: relative;
            margin-top: 109px;
            margin-right: 50px;
            width: 513px;
            height: 311px;
            .img-1 {
                width: 100%;
                height: 100%;
            }
            .img-2 {
                position: absolute;
                left: 186px;
                top: 38;
                width: 121px;
                height: 130px;
                animation: imganimation 2s;
                -webkit-animation: imganimation 2s;
                -ms-animation: imganimation 2s;
                -moz-animation: imganimation 2s;
                -o-animation: imganimation 2s;
                animation-iteration-count: infinite;
                -webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
                animation-direction:alternate;
                -webkit-animation-direction:alternate; /* Safari 和 Chrome */
            }
            @keyframes imganimation {
                0% {
                    top: 38px;
                }
                100% {
                    top: 28px;
                }
            }
        }
    }
    .item {
        padding: 56px 0 77px 0;
        .animated {
            opacity: 0;
        }
        .fadeInUp {
            opacity: 1;
        }
        .left-content {
            float: left;
            width: 570px;
            .name {
                position: relative;
                font-size: 26px;
                color: #333;
                &::before {
                    content: '';
                    position: absolute;
                    bottom: -10px;
                    width:36px;
                    height:2px;
                    background: #409EFF;
                }
            }
            .msg {
                margin-top: 38px;
                font-size: 16px;
                color: #666;
                line-height: 24px;
            }
        }
        .right-img {
            float: left;
            margin-left: 134px;
            img {
                width: 318px;
                height: 237px;
            }
        }
        &.item-1 {
            padding: 46px 0 37px 0;
            img {
                width: 414px;
                height: 287px;
            }
            .right-img {
                float: right;
            }
            .left-content {
                margin-top: 59px;
            }
        }
        &.item-2 {
            padding: 28px 0 28px 0;
            background: #F5F7FA;
            img {
                width: 461px;
                height: 314px;
            }
            .left-content {
                float: right;
                margin-top: 72px;
            }
            .right-img {
                margin-left: 0
            }
        }
        &.item-3 {
            padding: 33px 0;
            img {
                width: 461px;
                height: 305px;
            }
            .right-img {
                float: right;
            }
            .left-content {
                margin-top: 84px;
            }
        }
    }
    
    .server {
        padding: 40px 0 88px 0;
        background: #F5F7FA;
        .name {
                position: relative;
                text-align: center;
                padding: 10px 0;
                font-size: 26px;
                color: #333;
                &::before {
                    content: '';
                    position: absolute;
                    margin: auto;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width:36px;
                    height:2px;
                    background: #409EFF;
                }
        }
        .msg {
            margin-top: 46px;
            ul {
                height: 315px;

                li {
                    float: left;
                    width: 264px;
                    height: 305px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                    -webkit-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                    -ms-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                    -moz-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                    -o-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                    transition: all .6s;
                    -webkit-transition: all .6s;
                    -ms-transition: all .6s;
                    -o-transition: all .6s;
                    -moz-transition: all .6s;

                    border-radius:6px;
                    text-align: center;
                    &~li {
                        margin-left: 28px;
                    }
                    &:hover {
                        transition: all .6s;
                        -webkit-transition: all .6s;
                        -ms-transition: all .6s;
                        -o-transition: all .6s;
                        -moz-transition: all .6s;
                        margin-top: -10px;
                    }
                    img {
                        display: block;
                        margin: auto;
                        margin-top: 20px;
                        width: 80px;
                        height: 80px;
                    }
                    p {
                        font-size: 14px;
                        color: #666;
                        margin-top: 10px;
                        &.title {
                            margin-top: 20px;
                            margin-bottom: 20px;
                            font-size: 20px;
                            color: #333;
                        }
                    }
                    
                }
            }
        }
    }

}
</style>